// Ad attribution — captures utm_*/gclid from the ad landing URL on first touch and hands
// it back when the visitor books, so every booking can be traced to its campaign.
// Stored on the booking as `attribution` and shown on the admin customer card.
const KEY = "shs_utm";
const TRACKED = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export const captureAttribution = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const found = {};
    TRACKED.forEach((k) => {
      const v = p.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length) {
      localStorage.setItem(
        KEY,
        JSON.stringify({ ...found, first_page: window.location.pathname, at: new Date().toISOString() })
      );
    }
  } catch { /* private mode etc. — attribution just won't attach */ }
};

export const getAttribution = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};
